import * as React from 'react'
import { useIsIntersecting } from './useIsIntersecting'

type Options = {
  target: React.RefObject<HTMLElement | null>
  load: () => void
} & IntersectionObserverInit

export function useLazyInitialLoad({ target, load, ...options }: Options): void {
  const isIntersecting = useIsIntersecting(target, options)

  React.useEffect(() => {
    if (isIntersecting) {
      load()
    }
  }, [isIntersecting])
}
